import React, {Component} from 'react';
import { connect, Provider } from 'react-redux';
import {doAjax} from '../helpers.js';

import $ from 'jquery';

function SubidasP(props) {
  return(
    <div className="container main">
      <table className="table subidas">
        <thead>
          <tr><th/><th>Subida</th><th>Hora</th><th>Fotografo</th><th>Fotos</th><th>Estado</th></tr>
        </thead>
        <tbody>
          { props.subidas.map(i => {
            const f = props.fotografos[i.fotografo_id];
            return (<tr key={i.id} onClick={() => props.buscar(i.id)}>
                      <td><i className={"fa fa-circle"} style={{color: i.color}}/></td>
                      <td>{ i.id }</td>
                      <td>{ i.fecha }</td>
                      <td><img src={f.foto}/> {f.nombre}</td>
                      <td> {i.subidas}/{i.total}</td>
                      <td>{i.estado}</td>
                      { props.log ? <td><a href={"/admin/subida_log/"+i.id}>LOG</a></td> : null }
                    </tr>);
            })}
        </tbody>
      </table>
    </div>
    );
  }

function SubidasC(pref="", log=false) {
  return connect(st => ({fotografos: Config.fotografos, subidas: st.subidas, log}),
                               d => ({buscar: subida_id => {
                                                 const b = {buscador: {subida_id: subida_id}};
                                                 d({type: "STATUS_SET", v: b});
                                                 d(doAjax(pref+"/buscar?"+$.param(b), "GET"));
                                                 }})
                              )(SubidasP);
  }

export const Subidas = SubidasC("");
export const AdminSubidas = SubidasC("/admin", true);
